'use client';

// TODO: Evaluate import 'client only'
import Script from 'next/script';

import React, { useEffect } from 'react';

let currDataLayerName: string | undefined = undefined;
let currGtmUrl: string | undefined = 'https://www.googletagmanager.com';

export interface GoogleTagMangerProps {
    gtmId: string;
    dataLayer?: string[];
    dataLayerName?: string;
    auth?: string;
    preview?: string;
    gtmUrl?: string;
    cookieInformation?: boolean;
}

export interface CookieInformation {
    getConsentGivenFor: (category: string) => boolean;
}

declare const window: {
    CookieInformation: CookieInformation;
} & Window;

export function GoogleTagManager(props: GoogleTagMangerProps) {
    const { gtmId, dataLayerName = 'dataLayer', auth, preview, dataLayer, gtmUrl } = props;

    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }

    if (gtmUrl) {
        currGtmUrl = gtmUrl;
    }

    const gtmLayer = dataLayerName !== 'dataLayer' ? `$l=${dataLayerName}` : '';
    const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';

    useEffect(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora

        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-gtm',
            },
        });
    }, []);

    return (
        <>
            <Script
                id='_next-gtm-init'
                dangerouslySetInnerHTML={{
                    __html: `
                        (function(w,l){
                            w[l]=w[l]||[];
                            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                            ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
                        })(window,'${dataLayerName}');
                    `,
                }}
            />
            <Script
                id='_next-gtm'
                data-ntpc='GTM'
                src={`${currGtmUrl}/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}`}
            />
            <noscript
                dangerouslySetInnerHTML={{
                    __html: `<iframe src="${currGtmUrl}/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                }}></noscript>
        </>
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendGTMEvent = (data: Record<string, any>) => {
    if (currDataLayerName === undefined) {
        console.warn(`GTM has not been initialized`);
        return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any)[currDataLayerName]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any)[currDataLayerName].push(data);
    } else {
        console.warn(`GTM dataLayer ${currDataLayerName} does not exist`);
    }
};
